import * as React from 'react';
import {
  Heading2,
  Desc,
  LinkContainer,
  LinkButton,
  MainContainer,
  LinkButtonInternal,
} from './leftMenuDescStyle';
import isExternalUrl, {
  isExternalUrlhref,
  addTrailingSlash,
} from '../../../utils';

const LeftMenuDesc = (props) => {
  return (
    <>
      <MainContainer>
        <Heading2>{props?.title}</Heading2>
        <Desc>{props?.description}</Desc>
        {props?.link ? (
          <LinkContainer>
            {isExternalUrl(props?.link?.path) ? (
              <LinkButton
                href={
                  isExternalUrlhref(props?.link?.path)
                    ? props?.link?.path
                    : addTrailingSlash(
                        process.env.GATSBY_DOMAIN_URL + props?.link?.path
                      )
                }
                target="_blank"
              >
                {props?.link?.text}
              </LinkButton>
            ) : (
              <LinkButtonInternal
                to={
                  isExternalUrlhref(props?.link?.path)
                    ? props?.link?.path
                    : addTrailingSlash(
                        process.env.GATSBY_DOMAIN_URL + props?.link?.path
                      )
                }
              >
                {props?.link?.text}
              </LinkButtonInternal>
            )}
          </LinkContainer>
        ) : null}
      </MainContainer>
    </>
  );
};

export default LeftMenuDesc;
